var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-header",style:(_vm.headerStyles)},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon,"alt":"logo"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }